import { combineReducers, Action } from "@reduxjs/toolkit";
import { authApi } from "redux/services/auth";
import { walletApi } from "redux/services/wallet";
import { membershipApi } from "redux/services/membership";
import { dataLoaderApi } from "redux/services/dataLoader";
import { documentApi } from "redux/services/documentRepository";
import { auditApi } from "redux/services/auditRecord";
import {
  indetityApi,
  indetityApiAppToken,
  setPasswordApiAppToken,
} from "redux/services/identity";
import { accountApi } from "redux/services/account";
import authReducer, { logout } from "redux/slices/authSlice";
import { merchantApi } from "./services/merchant";
import { enterpriseApi } from "./services/enterprise";
import { paymentApi } from "./services/payment";
import { countryApi } from "./services/country";
import { businessActivityApi } from "./services/businessActivity";
import { bankApi } from "./services/bank";
import { reconciliationApi } from "./services/reconciliation";

const combinedReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  auth: authReducer,
  [walletApi.reducerPath]: walletApi.reducer,
  [membershipApi.reducerPath]: membershipApi.reducer,
  [dataLoaderApi.reducerPath]: dataLoaderApi.reducer,
  [documentApi.reducerPath]: documentApi.reducer,
  [auditApi.reducerPath]: auditApi.reducer,
  [indetityApi.reducerPath]: indetityApi.reducer,
  [indetityApiAppToken.reducerPath]: indetityApiAppToken.reducer,
  [setPasswordApiAppToken.reducerPath]: setPasswordApiAppToken.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [merchantApi.reducerPath]: merchantApi.reducer,
  [businessActivityApi.reducerPath]: businessActivityApi.reducer,
  [bankApi.reducerPath]: bankApi.reducer,
  [enterpriseApi.reducerPath]: enterpriseApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [countryApi.reducerPath]: countryApi.reducer,
  [reconciliationApi.reducerPath]: reconciliationApi.reducer,

});

const rootReducer = (state: any, action: Action) => {
  // clear store after logout
  if (action.type === logout.toString()) {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export default rootReducer;
